<template>
<v-row no-gutters>
  <v-col cols="12" class="pa-0">
    <SampleDropdownActionBar :sample="sample"></SampleDropdownActionBar>
  </v-col>
  <v-col cols="6" class="pt-1 pb-1">
<!--    {{sample}}-->
    <SampleEditForm :sample="sample"></SampleEditForm>
  </v-col>
  <v-col>
    <SampleNotesAndFlags :sample="sample"></SampleNotesAndFlags>
  </v-col>
</v-row>
</template>

<script>
export default {
    name: "TableDropdown",
    components: {
      SampleEditForm: () => import("@/views/Tracking/components/SampleEditForm"),
      SampleNotesAndFlags: () => import("@/views/Tracking/components/SampleNotesAndFlags"),
      SampleDropdownActionBar: () => import("@/views/Tracking/components/SampleDropdownActionBar")
    },
    props:{
      sample: {
        required: true,
      }
    },
    data: () => ({}),
    methods: {}
}
</script>

<style scoped>

</style>
